import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import { environment } from 'src/environments/environment';
import {lastValueFrom, Observable} from "rxjs";
import {TransferenciaModel} from "./transferencia.model";

@Injectable({
  providedIn: 'root'
})
export class TransferenciaService {
  constructor(private http: HttpClient)
  {
  }

  sendWithdraw(request : TransferenciaModel) : Observable<any>
  {
    return this.http.post<any>(`${environment.apiUrl}/withdraw`, request);
  }

  searchDICT(pixKey: string, pixType: string): Promise<any>
  {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("pixKey", pixKey);
    queryParams = queryParams.append("pixType", pixType);
    return lastValueFrom(this.http.get<any>(`${environment.apiUrl}/getPixKey`,{params: queryParams}))
  }

}

